<lui-form-field [class.readonly]="props.readonly">
  <lui-label
    class="d-block"
    [class.me-3]="field.props?.['tooltip']"
    [innerHTML]="field.props?.label | castObservable | async"
  >
  </lui-label>
  <ng-container #fieldComponent></ng-container>
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</lui-form-field>
